/**
 * Testimonials Carousel
 *
 * @package Altens
 */

export default function initTestimonialsCarousel(Swiper, Pagination) {
    const sliders = document.querySelectorAll("[data-testimonials-slider]");

    if (!sliders.length) return;

    sliders.forEach((slider) => {
        const wrapper = slider.querySelector(".swiper-wrapper");

        if (!wrapper) return;

        const slides = wrapper.querySelectorAll(".swiper-slide");

        if (slides.length <= 1) return;

        const pagination = slider.querySelector(".testimonials-grid__pagination");

        new Swiper(slider, {
            modules: [Pagination],

            slidesPerView: 1,
            spaceBetween: 16,

            speed: 600,
            loop: false,
            grabCursor: true,
            watchOverflow: true,

            pagination: {
                el: pagination,
                clickable: true,
            },

            breakpoints: {
                640: {
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                },

                768: {
                    slidesPerView: 1.5,
                    spaceBetween: 24,
                },

                1024: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
            },
        });
    });
}
